import React, { useState } from "react";
import { Button } from "antd";
import styled from "styled-components";
import PartPaymentForm from "components/widgets/forms/setup/Payment_Config";
import BasicDetails from "components/setup/BasicDetails";
import TableComponent from "components/widgets/table";
import { fetch_product_details } from "services/apiSrv";
import { useParams } from "react-router-dom";
import Loader from "components/widgets/loader";
import { useQuery } from "react-query";

// Styled Components
const Title = styled.h2`
  font-size: 20px;
  margin-bottom: 12px;
  color: #555;
`;

const Section = styled.div`
  margin-bottom: 48px;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
  margin-bottom: 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 8px rgb(0 0 0 / 0.1);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
  }

  th {
    background: #f4f4f4;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }
`;

export default function PaymentConfigSection() {
  const {id: productSystemRef} = useParams()
  // Example product table
  const [productItems] = useState([
    {
      id: 1,
      name: "Comprehensive Auto",
      ref: "AUTO123",
      underwriters: "ABC Insurance",
      productImage: "auto.jpg",
    },
  ]);

  // Example part payment configurations table
  const [paymentConfigs, setPaymentConfigs] = useState([
    {
      id: 1,
      period: 30,
      value: "5%",
      minAmount: 1000,
      maxPeriod: 60,
      minPeriod: 15,
    },
    {
      id: 2,
      period: 60,
      value: "10%",
      minAmount: 2000,
      maxPeriod: 90,
      minPeriod: 30,
    },
    {
      id: 3,
      period: 90,
      value: "15%",
      minAmount: 3000,
      maxPeriod: 120,
      minPeriod: 45,
    },
  ]);

  const handleDeleteConfig = (id) => {
    setPaymentConfigs(paymentConfigs.filter((item) => item.id !== id));
  };

  const handleOverallSave = () => {
    alert("Overall Save triggered! (UI only)");
  };

  


      const { data, isLoading, isError, error, refetch } = useQuery({
      queryKey: ['productDetails', productSystemRef],
      queryFn: () => fetch_product_details(productSystemRef),
      enabled: !!productSystemRef,
      retry: 2,
      staleTime: 5 * 60 * 1000,
    });
  
    if (isLoading) {
      return <Loader/>;
    }
  
    if (isError) {
      return <p>Error fetching product details: {error?.message || 'Something went wrong'}</p>;
    }
  
    if (!data?.data) {
      return <p>No product data available.</p>;
    }
  
    const { productName, productExcess, productPaymentConfig, productLiability,  productDescription, productPremium, basePremiumRate } = data.data[0];

    console.log("product pay config", productPaymentConfig)

  const productTableFields = [
    { name: "Max Part Payment Amount" },
    { name: "Min Part Payment Amount" },
    { name: "Number of Payments" },
    { name: "Min Part Payment Period" },
    { name: "Max Part Payment Period" },
    { name: "Is Payment Allowed" },
  ];

  const productRowData = [
    { type: "number", field: "maximumPartPaymentAmount" },
    { type: "number", field: "minimumPartPaymentPeriod" },
    { type: "text", field: "numberOfPartPayments" },
    { type: "text", field: "minimumPartPaymentPeriod" },
    { type: "text", field: "maximumPartPaymentPeriod" },
    { type: "boolean", field: "isPartPaymentAllowed" },
    
  ];

    const coverTableFields = [
    { name: "Cover" },
    { name: "Period" },

  ];

  const coverRowData = [
    { type: "number", field: "period" },
    { type: "number", field: "value" },
  ];
       

  return (
    <div>
      {/* Available Products */}
      <BasicDetails />

      {/* Part Payment Form */}
      <Section>
        <Title>Add Part Payment</Title>
        <PartPaymentForm refetchProductDetails={refetch} />
      </Section>

      {/* Part Payment Table */}
      <Section>
        <Title>Part Payment</Title>
        {productPaymentConfig && (
        <TableComponent
          table_fields={productTableFields}
          table_data={[productPaymentConfig]}
          row_data={productRowData}
          title=" "
        />
        )}


        {productPaymentConfig && (
        <TableComponent
          table_fields={coverTableFields}
          table_data={productPaymentConfig.partPayments}
          row_data={coverRowData}
          title=" "
        />
        )}

      
      </Section>

      {/* Overall Save Button */}
      <div
        style={{
          marginTop: "24px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          type="button"
          className="btn btn-success px-4 py-2"
          onClick={handleOverallSave}
        >
          Save
        </button>
      </div>
    </div>
  );
}
